module.exports = __webpack_public_path__ + "static/media/gryllus_campestris.1da6d930.png";